<template>
    <div style="min-height: 180px">
        <div v-if="clients" style="z-index: 1000">
            <md-autocomplete
                :md-fuzzy-search="false"
                :md-options="clients"
                :value="value"
                md-dense
                :md-input-placeholder="'Zoek op klant naam'"
                :md-open-on-focus="false"
                @md-changed="setClientList"
                @md-opened="setClientList"
                @md-selected="setSelectedClient"
                style="z-index: 1000"
            >
                <label>Klant</label>
                <template slot="md-autocomplete-item" slot-scope="{ item }">
                    {{
                        item.client_data.first_name +
                        ' (' +
                        (item.exact_client_number ? item.exact_client_number : 'LeadID: ' + item.client_id) +
                        ')'
                    }}
                </template>

                <template slot="md-autocomplete-item" slot-scope="{ item, term }">
                    <md-highlight-text :md-term="term">
                        {{
                            item.client_data.first_name +
                            ' (' +
                            (item.exact_client_number ? item.exact_client_number : 'LeadID: ' + item.client_id) +
                            ')'
                        }}
                    </md-highlight-text>
                </template>

                <template slot="md-autocomplete-empty" slot-scope="{ term }">
                    No customers matching "{{ term }}" were found!
                </template>
            </md-autocomplete>
        </div>
        <div class="md-layout-item">
            <md-field v-if="deliveryAddresses.length">
                <label>Uitvoer adres</label>
                <md-select
                    type="text"
                    name="delivery_address"
                    id="delivery_address"
                    v-model="selectedDeliveryAddressIndex"
                    @md-selected="setSelectedDeliveryAddress($event)"
                >
                    <md-option v-for="(address, index) in deliveryAddresses" :value="index" :key="index">
                        {{ `${address.address} ${address.zip_code}` }}
                    </md-option>
                </md-select>
            </md-field>
            <md-button v-if="deliveryAddresses.length" @click="showNewAddressDialog = true" class="md-primary">
                <md-icon>add</md-icon>
                Nieuw adres
            </md-button>
        </div>
        <md-dialog style="z-index: 9" :md-active.sync="showNewAddressDialog">
            <md-dialog-title> Voeg adres toe </md-dialog-title>

            <md-dialog-content>
                <md-list>
                    <form novalidate @submit.prevent="validateForm">
                        <div class="md-layout">
                            <div class="md-layout-item md-medium-size-50 md-small-size-100">
                                <div class="md-layout-item md-size-90 md-small-size-100">
                                    <md-field :class="getValidationClass('address')">
                                        <label for="first_name">Adres</label>
                                        <md-input
                                            required
                                            name="address"
                                            id="address"
                                            v-model="newAddress.address"
                                            :disabled="sending"
                                        />
                                        <span class="md-error" v-if="!$v.newAddress.address.required"
                                            >Verplicht in te vullen!</span
                                        >
                                        <span class="md-error" v-else-if="!$v.newAddress.address.minLength"
                                            >adres is te kort</span
                                        >
                                    </md-field>
                                </div>
                                <div class="md-layout-item md-size-90 md-small-size-100">
                                    <md-field :class="getValidationClass('zip_code')">
                                        <label for="last_name">Postcode</label>
                                        <md-input
                                            required
                                            name="zip_code"
                                            id="zip_code"
                                            v-model="newAddress.zip_code"
                                            :disabled="sending"
                                        />
                                        <span class="md-error" v-if="!$v.newAddress.zip_code.required"
                                            >Verplicht in te vullen!</span
                                        >
                                        <span class="md-error" v-else-if="!$v.newAddress.zip_code.minLength"
                                            >zipcode is te kort</span
                                        >
                                    </md-field>
                                </div>
                                <div class="md-layout-item md-size-90 md-small-size-100">
                                    <md-field :class="getValidationClass('city')">
                                        <label for="address">Stad</label>
                                        <md-input
                                            required
                                            name="city"
                                            id="city"
                                            v-model="newAddress.city"
                                            :disabled="sending"
                                        />
                                        <span class="md-error" v-if="!$v.newAddress.city.required"
                                            >Verplicht in te vullen!</span
                                        >
                                    </md-field>
                                </div>
                                <div class="md-layout-item md-size-90 md-small-size-100">
                                    <md-field :class="getValidationClass('countryName')">
                                        <label for="city">Land</label>
                                        <md-input
                                            required
                                            name="country_name"
                                            id="country_name"
                                            v-model="newAddress.countryName"
                                            :disabled="sending"
                                        />
                                        <span class="md-error" v-if="!$v.newAddress.countryName.required"
                                            >Verplicht in te vullen!</span
                                        >
                                    </md-field>
                                </div>
                                <div class="md-layout-item md-size-90 md-small-size-100">
                                    <md-field :class="getValidationClass('stateName')">
                                        <label for="city">Provincie</label>
                                        <md-input
                                            required
                                            name="state_name"
                                            id="state_name"
                                            v-model="newAddress.stateName"
                                            :disabled="sending"
                                        />
                                        <span class="md-error" v-if="!$v.newAddress.stateName.required"
                                            >Verplicht in te vullen!</span
                                        >
                                    </md-field>
                                </div>
                            </div>
                        </div>
                    </form>
                </md-list>
            </md-dialog-content>
            <md-dialog-actions>
                <md-button @click="cancelNewAddress()" class="md-primary">Cancel</md-button>
                <md-button @click="validateForm()" class="md-primary">Save</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { ReplaySubject } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';
import {
    ClientApi,
    ClientState,
    IAddress,
    IClientEntity,
    IClientFilterEntity,
    RequestSort,
} from '@phrospr/api-backend';
import toastr from 'toastr';
import { minLength, required } from 'vuelidate/lib/validators';
import { IVuelidateComponentOptions } from '@/services/entities/vuelidate.entity';

@Component({
    components: {},
    validations: {
        newAddress: {
            address: { required, minLength: minLength(2) },
            zip_code: { required, minLength: minLength(2) },
            city: { required, minLength: minLength(2) },
            countryName: { required, minLength: minLength(2) },
            stateName: { required, minLength: minLength(2) },
        },
    },
} as IVuelidateComponentOptions)
export default class ClientSearchModal extends Vue {
    // Restrict results to real clients (no leads) — e.g. work orders.
    @Prop({ default: false }) clientsOnly: boolean;

    filter: { clientName: string } = {
        clientName: '',
    };

    selectedClient: IClientEntity = null;
    term = '';
    value = '';
    selectedClientValue = '';

    searchTerm$ = new ReplaySubject(1);
    searchTermSubscription;

    deliveryAddresses: IAddress[] = [];
    selectedDeliveryAddressIndex: number = 0;
    showNewAddressDialog = false;
    newAddress: IAddress = this.resetAddress();
    $v: any;
    invalidForm = false;
    sending = false;

    get clients() {
        return Promise.resolve(this.$store.state.clientSearch);
    }

    constructor() {
        super();
        this.searchTermSubscription = this.searchTerm$
            .pipe(
                debounceTime(300),
                tap((searchTerm: string) => {
                    if (searchTerm === undefined || this.selectedClientValue === searchTerm) {
                        this.$store.commit('setClientSearch', []);
                        return;
                    }
                    this.filter.clientName = searchTerm;
                    this.searchClients();
                }),
            )
            .subscribe();
    }

    async validateForm() {
        this.invalidForm = false;
        this.$v.$touch();
        if (!this.$v.$invalid) {
            await this.addNewAddress();
            this.showNewAddressDialog = false;
        } else this.invalidForm = true;
    }

    getValidationClass(fieldName) {
        const keys = fieldName.split('.');
        let field = this.$v.newAddress[keys[0]];
        for (let i = 1; i < keys.length; i++) field = field[keys[i]];
        if (field) {
            return {
                'md-invalid': field.$invalid && field.$dirty,
            };
        }
    }

    setClientList = searchTerm => {
        this.searchTerm$.next(searchTerm);
    };

    async searchClients() {
        const ClientSearchFilter: IClientFilterEntity = {
            filter: this.clientsOnly ? { ...this.filter, state: ClientState.client } : this.filter,
            limit: 10,
            // clientName also matches the client number. With a term: best match first, then by
            // name; without one: by client number.
            sort: this.filter?.clientName
                ? { order: RequestSort.ASC, column: 'relevance' }
                : { order: RequestSort.ASC, column: 'client_number' },
            offset: 0,
            show: {},
        };
        try {
            this.$store.commit('setClientSearch', (await ClientApi.listClients(ClientSearchFilter)).data.clients);
            this.$forceUpdate();
        } catch (e) {
            console.log(e);
            toastr.error('er ging iets mis bij het zoeken naar een client');
        }
    }

    @Emit() async setSelectedClient(selectedClient) {
        this.selectedClient = selectedClient;
        await this.getDeliveryAddresses(selectedClient);
        this.selectedClientValue =
            selectedClient.client_data.first_name + ' (' + selectedClient.exact_client_number + ')';
        return selectedClient;
    }

    @Emit() async setSelectedDeliveryAddress(indexDeliveryAddress: number) {
        return this.deliveryAddresses[indexDeliveryAddress];
    }

    async getDeliveryAddresses(client: IClientEntity) {
        this.deliveryAddresses = [];
        this.deliveryAddresses.push(client.client_data.main_address);
        if (client.client_data.delivery_addresses) {
            for (let i = 0; i < client.client_data.delivery_addresses.length; i++) {
                if (!client.client_data.delivery_addresses[i].deleted)
                    this.deliveryAddresses.push(client.client_data.delivery_addresses[i]);
            }
        }
        this.setSelectedDeliveryAddress(0);
    }

    cancelNewAddress() {
        this.newAddress = this.resetAddress();
        this.showNewAddressDialog = false;
    }

    resetAddress() {
        return {
            address: null,
            city: null,
            zip_code: null,
            countryName: null,
            stateName: null,
        };
    }

    async addNewAddress() {
        try {
            await ClientApi.addClientDeliveryAddress(this.selectedClient.client_id, this.newAddress);
            await this.updateNewDeliveryAddresses();
            this.newAddress = this.resetAddress();
        } catch (e) {
            console.log(e);
            toastr.error('er ging iets mis bij het aanmaken van adres');
        }
    }

    async updateNewDeliveryAddresses() {
        this.selectedClient = (await ClientApi.getClient(this.selectedClient.client_id)).data;
        await this.setSelectedClient(this.selectedClient);
    }
}
</script>

<style scoped>
.md-menu-content-bottom-start {
    z-index: 1000;
}
</style>
